
    $('.our-story-carousel').owlCarousel({
      loop: true,
      margin: 20,
      nav: true,
      dots: false,
      autoplay: false,
      autoplayTimeout: 4000,
      items: 1,
       navText: [
        '<img src="https://cdn.shopify.com/s/files/1/0727/7772/8196/files/back_1.png?v=1764740416" alt="prev" />',
        '<img src="https://cdn.shopify.com/s/files/1/0727/7772/8196/files/next_2.png?v=1764740414" alt="next" />'
      ]
    });

